// validators for various data
// deeply inspired from skills-server app/schemas/utils.py

import XRegExp from 'xregexp'
// const XRegExp = require('xregexp')
import { format } from './utils'
window.XRegExp = XRegExp

const IDENTIFIER_PATTERN = '[0-9a-f]{32}'
export const IDENTIFIER_REGEX = new XRegExp(
  format('^%s$', IDENTIFIER_PATTERN))

// the pattern of a variable name
const VARIABLE_PATTERN = '[A-Za-z_][A-Za-z_0-9]*'
export const VARIBALE_REGEX = new XRegExp(
  format('^%s$', VARIABLE_PATTERN))

const IDENTIFIER_VARIABLE_PATTERN = format('(?:%s|%s)',
  IDENTIFIER_PATTERN, VARIABLE_PATTERN)

// charactes that can be part of a word (and numbers)
const LETTER_CHAR = '\\p{L}\\p{M}0-9%+×\\-'
// the characters accepted in a word, including number, as a class
const LETTER_CLASS = format('[%s]', LETTER_CHAR)

// other characters that can be part of a name, not necessarily readable
const ACCEPTABLE_CHAR = '!"#$%&\'()*+,./:;<=>?@\\[\\]_{|}~-'
// all together in a class
const ACCEPTABLE_CLASS = format('[%s %s]', LETTER_CHAR, ACCEPTABLE_CHAR)
export const ACCEPTABLE_REGEX = new XRegExp(
  format('^%s+$', ACCEPTABLE_CLASS), 'u')

// other characters that can be read in an answer
const READABLE_CHAR = ':!\'",.?'
// all together in a class
const READABLE_CLASS = format('[%s %s]', LETTER_CHAR, READABLE_CHAR)
export const READABLE_REGEX = new XRegExp(format('^%s+$', READABLE_CLASS), 'u')

// all the characters than can be part of an input
// for displaying errors while typing
export const PRE_INPUT_REGEX = new XRegExp(format('^[%s _(|)@#:%s]*$',
  LETTER_CHAR, READABLE_CHAR), 'u')

// the complete regex for an input string
const INPUT_SEPARATOR_CLASS = '[ !%,.?(|)]'
let INPUT_ENTITY, INPUT_SYNONYM
try {
  INPUT_ENTITY = format('(?:(?<={0})|^)@{1}:(?:{2}|null)(?={0}|$)',
    INPUT_SEPARATOR_CLASS, VARIABLE_PATTERN, IDENTIFIER_VARIABLE_PATTERN)
  INPUT_SYNONYM = format('(?:(?<={0})|^)#{1}+:{2}(?={0}|$)',
    INPUT_SEPARATOR_CLASS, READABLE_CLASS, IDENTIFIER_VARIABLE_PATTERN)
  new XRegExp(INPUT_ENTITY) // eslint-disable-line no-new
  new XRegExp(INPUT_SYNONYM) // eslint-disable-line no-new
// only chrome supports look-behind, so forget it
} catch (e) {
  INPUT_ENTITY = format('@{1}:(?:{2}|null)(?={0}|$)',
    INPUT_SEPARATOR_CLASS, VARIABLE_PATTERN, IDENTIFIER_VARIABLE_PATTERN)
  INPUT_SYNONYM = format('#{1}+:{2}(?={0}|$)',
    INPUT_SEPARATOR_CLASS, READABLE_CLASS, IDENTIFIER_VARIABLE_PATTERN)
}
export const INPUT_REGEX = new XRegExp(format(
  '^(?:{0}|{1}|{2}|\\((?:(?:{0}|{2})*\\|)+(?:{0}|{2})*\\))+$',
  READABLE_CLASS, INPUT_ENTITY, INPUT_SYNONYM), 'u')

export const PRE_EXAMPLE_REGEX = new XRegExp(
  format('^[%s _{@:}%s]*$', LETTER_CHAR, READABLE_CHAR), 'u')

const SLOT_TEXT_PATTERN = format('{0}(?:{1}*{0})?', LETTER_CLASS, READABLE_CLASS)
export const SLOT_TEXT_REGEX = new XRegExp('^' + SLOT_TEXT_PATTERN + '$', 'u')
export const EXAMPLE_REGEX = new XRegExp(
  format('^(?:{0}|(?:^|[ {1}])\\{@{2}:{3}\\}(?=[ {1}]|$))+$',
    READABLE_CLASS, READABLE_CHAR, VARIABLE_PATTERN, SLOT_TEXT_PATTERN), 'u')

// all the characters than can be part of an output
// for displaying errors while typing
export const PRE_OUTPUT_REGEX = new XRegExp(format('^[%s _(|){}@$%s]*$',
  LETTER_CHAR, READABLE_CHAR), 'u')

// the complete regex for an output string
// const OUTPUT_SUB = format('{1}+|(?:(?<=[^{0})])|^)[@$]{2}(?=[^{0}(@]|$)',
//   LETTER_CHAR, READABLE_CLASS, VARIABLE_PATTERN)
let OUTPUT_SUB
try {
  OUTPUT_SUB = format('{1}|\\{[{0}](?:{1}*[{0}])?\\}|(?:(?<=[^{0})])|^)[@$]{2}(?=[^{0}(@]|$)',
    LETTER_CHAR, READABLE_CLASS, VARIABLE_PATTERN)
  new XRegExp(OUTPUT_SUB) // eslint-disable-line no-new
// only chrome supports look-behind, so forget it
} catch (e) {
  OUTPUT_SUB = format('{1}|\\{[{0}](?:{1}*[{0}])?\\}|[@$]{2}(?=[^{0}(@]|$)',
    LETTER_CHAR, READABLE_CLASS, VARIABLE_PATTERN)
}
export const OUTPUT_REGEX = new XRegExp(format('^(?:{0}|' +
  '\\((?:(?:{0}|)\\|)+(?:{0}|)\\))+$', OUTPUT_SUB), 'u')

// all the characters than can be part of a synonym option
// for displaying errors while typing
export const PRE_SYNONYM_REGEX = new XRegExp(format('^[%s (|)%s]*$',
  LETTER_CHAR, READABLE_CHAR), 'u')

// the complete regex for a synonym option
export const SYNONYM_REGEX = new XRegExp(format(
  '^(?:{0}|\\((?:{0}*\\|)+{0}*\\))+$', READABLE_CLASS), 'u')
// a regex to check that a synonym option is not empty
export const SYNONYM_REGEX_EMPTY = new XRegExp(format(
  '^(?:[^()]*\\([^()]*\\))*[^()]*' +
  '(?:{0}|\\((?:[^(|)]*{0}[^(|)]*\\|)*[^(|)]*{0}[^(|)]*\\))',
  LETTER_CLASS), 'u')

// the regex of an url
export const URL_REGEX = new XRegExp(format(
  '^https?://[a-z0-9-.]+(?::[0-9]+)?/.*|^@%s$', IDENTIFIER_VARIABLE_PATTERN))

// the regex of a header name
export const HEADER_NAME_REGEX = new XRegExp('^[a-zA-Z0-9]+(?:-[a-zA-Z0-9]+)*$')

// the regex for oauth2 scopes
export const OAUTH2_SCOPES_REGEX = new XRegExp('^[!#-\\]\\[-~]+(?: [!#-\\]\\[-~]+)*$')
// the regex for an oauth2 scope
export const OAUTH2_SCOPE_REGEX = new XRegExp('^[!#-\\]\\[-~]+$')

export const STRING_VAR_REGEX = new XRegExp(format(
  '^(?:[^$@]|\\$\\$|@@|[$@]{0}|[$@]\\{{0}\\})+$', VARIABLE_PATTERN))

export const FORBIDDEN_HEADERS = Object.fromEntries([
  // officially forbidden headers
  // https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
  'Accept-Charset',
  'Accept-Encoding',
  'Access-Control-Request-Headers',
  'Access-Control-Request-Method',
  'Connection',
  'Content-Length',
  'Cookie',
  'Cookie2',
  'Date',
  'DNT',
  'Expect',
  'Feature-Policy',
  'Host',
  'Keep-Alive',
  'Origin',
  'Referer',
  'TE',
  'Trailer',
  'Transfer-Encoding',
  'Upgrade',
  'Via',
  // other request headers
  // https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers
  'Charset',
  'Content-Type',
  'Cache-Control',
  'Pragma',
  'Warning',
  'Device-Memory',
  'DPR',
  'Viewport-Width',
  'Width',
  'Downlink',
  'ECT',
  'RTT',
  'Save-Data',
  'If-Match',
  'If-None-Match',
  'If-Modified-Since',
  'If-Unmodified-Since',
  'Accept',
  'From',
  'User-Agent',
].map(h => [h.toLowerCase(), true]))
export const FORBIDDEN_HEADER_PREFIXES = Object.fromEntries([
  // officially forbidden header prefixes
  // https://developer.mozilla.org/en-US/docs/Glossary/Forbidden_header_name
  'Proxy',
  'Sec',
].map(h => [h.toLowerCase(), true]))

// a generic validator generator
function RegexValidator (regex, message, trigger) {
  return {
    validator: (rule, value, callback) => {
      if (!value || value.match(regex)) return callback()
      console.log('RegexValidator.validator', JSON.stringify(value), JSON.stringify(regex))
      callback(new Error(message))
    },
    trigger: trigger,
  }
}

// variables names
export const VariableValidator = RegexValidator(VARIBALE_REGEX,
  'invalid variable name', 'blur')
// objects name
export const AcceptableValidator = RegexValidator(ACCEPTABLE_REGEX,
  'contains invalid characters')
// synonym text
export const ReadableValidator = RegexValidator(READABLE_REGEX,
  'contains invalid characters')
// input string (while typing)
export const PreInputValidator = RegexValidator(PRE_INPUT_REGEX,
  'contains invalid characters')
// input string (final)
export const InputValidator = RegexValidator(INPUT_REGEX,
  'invalid input', 'blur')
// input string (final)
export const SlotTextValidator = RegexValidator(SLOT_TEXT_REGEX,
  'invalid slot text', 'blur')
// input string (while typing)
export const PreExampleValidator = RegexValidator(PRE_EXAMPLE_REGEX,
  'contains invalid characters')
// input string (final)
export const ExampleValidator = RegexValidator(EXAMPLE_REGEX,
  'invalid example', 'blur')
// output string (while typing)
export const PreOutputValidator = RegexValidator(PRE_OUTPUT_REGEX,
  'contains invalid characters')
// output string (final)
export const OutputValidator = RegexValidator(OUTPUT_REGEX,
  'invalid message', 'blur')
// synonym option (while typing)
export const PreSynonymValidator = RegexValidator(PRE_SYNONYM_REGEX,
  'contains invalid characters')
// synonym option (final)
export const SynonymValidator = RegexValidator(SYNONYM_REGEX,
  'invalid option', 'blur')
// synonym option (not empty)
export const EmptySynonymValidator = RegexValidator(SYNONYM_REGEX_EMPTY,
  'matches empty input', 'blur')
// URL
export const URLValidator = RegexValidator(URL_REGEX, 'invalid URL', 'blur')
export const HTTPSValidator = {
  validator: (rule, value, callback) => {
    if (!value || value.startsWith('https://')) return callback()
    callback(new Error('URL must be HTTPS'))
  },
  trigger: 'blur',
}
// Header name
export const HeaderNameValidator = RegexValidator(HEADER_NAME_REGEX, 'invalid header name', 'blur')
// URL
export const ScopeValidator = RegexValidator(OAUTH2_SCOPE_REGEX, 'invalid scope')
// String with variables
export const StringVarValidator = RegexValidator(STRING_VAR_REGEX, 'invalid string', 'blur')

export function cleanUrl (url) {
  const pos = url.indexOf('?')
  if (pos >= 0 && pos < url.length - 1) {
    url = url.replace(/[&]+$/, '')
    if (pos < url.length - 1) return url
  }
  return url.replace(/[/?]+$/, '')
}

export function urlMatchPrefix (url, prefix) {
  url = cleanUrl(url)
  if (!url.startsWith(prefix)) {
    return prefix.indexOf('?') === prefix.length - 1 &&
      prefix.substr(0, prefix.length - 1) === url
  }
  if (prefix === url) return true
  const pos = prefix.indexOf('?')
  if (pos < 0 || pos === prefix.length - 1) {
    return prefix[prefix.length - 1].match(/[/?]/) || url[prefix.length].match(/[/?]/)
  }
  return prefix[prefix.length - 1] === '&' || url[prefix.length] === '&'
}

export function urlWhitelistSummary (whitelist, blacklist) {
  const list = [
    ...(whitelist || []).map(prefix => [prefix, true]),
    ...(blacklist || []).map(prefix => [prefix, false]),
  ]
  list.sort(([pa, wa], [pb, wb]) =>
    (pa.length > pb.length) - (pa.length < pb.length) || wa - wb)
  return list
}

export function urlMatchWhitelist (url, whitelist, required, callback) {
  callback = callback || (error => !error)
  for (let [prefix, white] of whitelist) {
    if (urlMatchPrefix(url, prefix)) {
      if (white) {
        return callback()
      } else {
        return callback(new Error(
          'url matches the API\'s blacklist'))
      }
    }
  }
  if (required) {
    return callback(new Error(
      'url doesn\'t match the API\'s whitelist'))
  }
  return callback()
}

export const HeaderAllowedValidator = {
  validator: (rule, value, callback) => {
    value = (value || '').toLowerCase()
    if (FORBIDDEN_HEADERS[value] || FORBIDDEN_HEADER_PREFIXES[value.split('-')[0]]) {
      return callback(new Error('forbidden header'))
    }
    callback()
  },
  trigger: 'blur',
}
